<template>
    <router-view/>
  </template>
  <script>
    export default {
        beforeRouteUpdate(to, from, next) {
            if(to.name == 'ven-regras-desconto'){
                next({ name: 'ven-regras-desconto-list' })
            }else{
                next()
            }
        },
        created() {
            if(this.$route.name == 'ven-regras-desconto'){
                this.$router.push({ name: 'ven-regras-desconto-list' })
            }
        }
    }
  </script>